function refresh_free_gift(callback) {
  var free_gift_over_price_10000 = 10000;
  var variant_id='43003615936740';
  var charge_variant_id='42829346668772';
    var GetParams = {
      type: 'GET',
      url: '/cart.js',
      data: {  },
      dataType: 'json',
      success: function(cart) { 
          var cartItems = cart.items  ,
            qtyInTheCart = 0,
            chargeQtyInTheCart = 0,
            cartUpdates = [],
            cartTotal = cart.total_price ;
        for (var i=0; i<cartItems.length; i++) {
          if ( cartItems[i].id == variant_id ) {
            qtyInTheCart += cartItems[i].quantity;
          }
          if ( cartItems[i].id == charge_variant_id ) {
            chargeQtyInTheCart += cartItems[i].quantity;
          }
        }
        
        // if(chargeQtyInTheCart>0 && qtyInTheCart>0 ){
        //   return;
        // }
    
        if(qtyInTheCart==0 && cartItems.length >= 1 && (cartTotal >= free_gift_over_price_10000  )){
          cartUpdates=[{id:variant_id,quantity:1 }]
        }
        
        // if(chargeQtyInTheCart==0 && cartItems.length >= 1 && (cartTotal >= 1500  )){
        //   cartUpdates.push({id:charge_variant_id,quantity:1 });
        // }

        if(cartUpdates.length==0){
          return;
        }
        
        var params = {
          type: 'POST',
          url: '/cart/add.js',
          data: { items: cartUpdates },
          dataType: 'json',
          success: function(stuff) { 
            //window.location.href = '/cart';
            document.documentElement.dispatchEvent(
              new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
              if(callback!=null){
                callback();
              }
            
          }
        };
        $.ajax(params);
      }
    };
    
    $.ajax(GetParams);
    
  }